import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "./RevenueComponent.css";
import RevenueCard from "./RevenueCard";
import { Payments, PaymentArrowDown, AccWallet, account_balance, verifylogo } from "../../assets/images/images";
import Tabs from "../CustomTabs/Tabs";
import WithdrawHistoryTable from "./WithdrawHistoryTable";
import CourseRevenue from "./RevenueHistory"
import api from "../../api/api";
import { useAuth } from "../../features/auth/AuthContext";
import BackButton from "../BackButton/BackButton";
import FloatingAIButton from "../FloatingAIButton/FloatingAIButton";
import { useDispatch, useSelector } from "react-redux";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../state/reducers/chatDrawerReducers";
import { Tooltip } from "react-tooltip";
import MeetingRevenue from "./MeetingRevenue";

function RevenueComponent() {
  const navigate = useNavigate();
  const { token } = useAuth()
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true)
  const [showVerifyPopup, setshowVerifyPopup] = useState(false)
  const isVerified = data?.bank_verification?.is_verified ?? "False";
  const dispatch = useDispatch();
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const withdrawThreshold = data?.currency_symbol === "$" ? 10 : 1000;

  const tabs = [
    { label: "Withdraw history", id: 1, key: "Withdraw", content: <WithdrawHistoryTable /> },
    { label: "Course Revenue", id: 2, key: "Revenue", content: <CourseRevenue /> },
    { label: "Meeting Revenue", id: 3, key: "Meeting", content: <MeetingRevenue /> }
  ]

  const fetchWidrawal = async () => {
    try {
      const response = await api.get('/payouts/revenue/analytics/', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      if (response.status === 200 || response.status === 201) {
        const data = response?.data?.data;
        setData(data)

      } else {
        console.error(response);

      }
    } catch (error) {
      console.log(error);

    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    fetchWidrawal()
  }, [])

  const handleRequestpayout = () => {
    if (isVerified === true) {
      navigate("/request-payout", { state: { data } })

    } else {
      setshowVerifyPopup(true)
    }
  }

  return (
    <>
      <div className="revenue-container">
        {/* Back Button */}
        {/* <div className="back-button" onClick={() => navigate(-1)}>
          <i className="fa-solid fa-chevron-left"></i>
          <span>Back</span>
        </div> */}
        <div className="back-button" >
          <BackButton buttonName={"Back"} fallbackPath="/dashboard" />
        </div>

        {/* Header */}
        <h2 className="my-[1.5rem] page-title font-medium text-black">Course Revenue Detailed Analytics</h2>

        {/* Top Section */}
        <div className="flex items-start justify-between flex-col lg:flex-row w-full gap-3">
          <div className=" grid grid-cols-1 w-full md:grid-cols-3 gap-2 lg:w-3/5">
            <RevenueCard head="Total Earnings" value={new Intl.NumberFormat("en-IN").format(data?.total_earnings ?? 0)} icon={Payments} data={data} />
            <RevenueCard head="Balance" value={new Intl.NumberFormat("en-IN").format(data?.balance ?? 0)} valueBold={true} icon={AccWallet}data={data}  balText={`Amount Withdrawn: ${data?.currency_symbol || ""}${new Intl.NumberFormat("en-IN").format(data?.amount_withdrawn ?? 0)}`} />
            <RevenueCard head="Available to withdraw" value={new Intl.NumberFormat("en-IN").format(data?.available_to_withdraw ?? 0)} icon={PaymentArrowDown}    infoText={true} data={data} />
          </div>

          <div className="right-actions w-full text-center md:w-auto">
            {
              isVerified === true && <div className="verified">
                Account Verified <i className="fa-solid fa-circle-check"></i>
              </div>
            }
            <div data-tooltip-id={ data?.total_earnings < withdrawThreshold ? "copy-button" : undefined}>

              <button
                className="payout-btn w-full md:w-auto"
                onClick={handleRequestpayout}
                disabled={loading || data?.total_earnings < withdrawThreshold}>
                <img src={account_balance} alt="payout" />
                Withdraw
              </button>
            </div>
          </div>
        </div>
     {
      data.total_earnings >0 &&    <p className="info-text text-[#333333] font-normal italic text-[0.8rem] tracking-normal my-[0.5rem]">
          You can withdraw once your Total Earnings reaches{" "}
          {data?.currency_symbol || ""}
          {data?.currency_symbol === "$" ? "10" : "1000"}{" "}
          or more. Payouts are processed to your verified bank account.
        </p>
     }

        <Tooltip
          id="copy-button"
            style={{ maxWidth: "300px", whiteSpace: "normal" }}
          place="top"
          content={`You can withdraw once your Total Earnings reaches ${data?.currency_symbol || ""
            }${data?.currency_symbol === "$" ? "10" : "1000"} or more. Payouts are processed to your verified bank account.`}
        />
              
        <Tabs tabList={tabs} />
            
        {/* Search & Actions */}


      </div>

      {showVerifyPopup && <>
        <div className="overlay">
          <div className="popup">


            {/* <h3>Bank Verification Required</h3> */}
            <img src={verifylogo} alt="verify logo" />
            <h3>
              Looks like you have not verified your bank yet.
            </h3>
            <p>
               Payouts are paused until bank details are verified.
            </p>

            <div className="popup-actions">
              <button
                className="cancel-btn"
                onClick={() => setshowVerifyPopup(false)}
              >
                Skip for now
              </button>
              <button
                className="confirm-btn"
                onClick={() => {
                  setshowVerifyPopup(false);
                  navigate("/dashboard/settings", {
                    state: { activeTab: "accountDetails" }
                  });             // onVerified();
                  //console.log("Verify Bank Account:", bankAccountId);
                }}
              >
                Verify Account
              </button>
            </div>
          </div>
        </div>
      </>}

      <FloatingAIButton
        onClick={() => {
          dispatch(setDrawerState(!chatDrawerState.isOpen));
          dispatch(setIsWebAllowed(true));
          dispatch(setQueryMetaData(null));
        }}
      />
    </>

  );
}

export default RevenueComponent;
